import { Box, Chip, Grid2, Typography } from "@mui/material";
import { ReactComponent as LockIcon } from "Assets/Icons/Home/LockIcon.svg";
import { ReactComponent as PeopleIcon } from "Assets/Icons/Home/PeopleIcon.svg";
import { ReactComponent as CoinIcon } from "Assets/Icons/Home/CoinIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React from "react";
import PrimarySlider from "Components/Common/PrimarySlider";
import { SwiperSlide } from "swiper/react";

const styles = (theme) => ({
  "& .emptyMsg": {
    minHeight: "100px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  "& .lockedMsg": {
    minHeight: "100px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "8px",
  },
  "& .assignmentHead": {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "15px",
  },
  "& .completedQues": {
    background: theme.palette.purple.light,
    padding: "16px",
    textAlign: "center",
    borderRadius: "8px",
    marginRight: "15px",
    whiteSpace: "nowrap",
    height: "100%",
  },
  "& .assignmentBox": {
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    cursor: "pointer",
    minHeight: "98px",
    "&:hover": {
      background: theme.palette.background.default,
    },
  },
});

const Assignment = () => {
  return (
    <Grid2 sx={styles}>
      {false ? (
        <Box className="emptyMsg">
          <Typography>No assignment problems to solve in this class</Typography>
        </Box>
      ) : false ? (
        <Box className="lockedMsg">
          <PrimaryIcon icon={LockIcon} />
          <Typography variant="title" fontWeight={500}>
            Assignment - Advanced Hypothesis Testing
          </Typography>
          <Typography variant="body2" color="secondary.light">
            This Assignment will be unlocked once the live lecture is completed
          </Typography>
        </Box>
      ) : (
        <Grid2>
          <Grid2 className="assignmentHead">
            <Box gap={"5px"} display={"flex"} flexDirection={"column"}>
              <Typography variant="title" fontWeight={500}>
                Walmart : Confidence Interval and CLT
              </Typography>
              <Typography color="secondary.light">
                Practice for real world technical interview by completing this
                business case
              </Typography>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              gap="6px"
              sx={(theme) => ({
                "& svg": {
                  padding: "10px 8px",
                  border: `1px solid ${theme.palette.border.blue}`,
                  borderRadius: "4px",
                  background: theme.palette.background.default,
                },
              })}
            >
              <PrimaryIcon icon={PeopleIcon} width="30px" height="22px" />
              <div>
                <Typography variant="body2">Mastery Mode Ends in</Typography>
                <Typography color="error" fontWeight={500} variant="title">
                  05d : 02h : 12m : 10s
                </Typography>
              </div>
            </Box>
          </Grid2>
          <Grid2 display={"flex"}>
            <Box className="completedQues" width={"fit-content"}>
              <Typography fontWeight={600} fontSize={"30px"} color="purple">
                0/8
              </Typography>
              <Typography>Questions Completed</Typography>
            </Box>
            <PrimarySlider spacing={"15px"}>
              {[...Array(10)].map((item, i) => {
                return (
                  <SwiperSlide>
                    <Grid2
                      key={`assignment${i}`}
                      size={2}
                      className="assignmentBox"
                    >
                      <Typography fontWeight={500}>
                        Day 115: Energy Consumption
                      </Typography>
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Chip
                          variant="outlined"
                          color="success"
                          outlined
                          label="Easy"
                        />
                        <Typography
                          display={"flex"}
                          alignItems={"center"}
                          gap="6px"
                        >
                          <PrimaryIcon
                            height="12px"
                            width="16px"
                            icon={PeopleIcon}
                          />
                          1
                          <PrimaryIcon
                            height="16px"
                            width="16px"
                            icon={CoinIcon}
                          />
                          50
                        </Typography>
                      </Box>
                    </Grid2>
                  </SwiperSlide>
                );
              })}
            </PrimarySlider>
          </Grid2>
        </Grid2>
      )}
    </Grid2>
  );
};

export default Assignment;
